import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "../../../enums/reducer";
import { type Domain } from "../../Library/SimulatedPhishing/Domains/types/state";
import { type FetchingItemsState, createFetchingItemsSlice } from "../../Application/slices/createFetchingItemsSlice";

export interface DomainManagementState extends FetchingItemsState<Domain> {}

export const initialState: DomainManagementState = {
  items: [],
  itemsCount: 0,
  isLoading: false,
  error: undefined,
};

const domainManagementSlice = createFetchingItemsSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Accounts,
    entity: ReducerEntityPrefixTypes.ThreatDefenceDomainManagement,
    name: "domainManagement",
  },
  initialState,
  reducers: {
    reset() {
      return { ...initialState };
    },
  },
});

export const { reset, fetchBegin, fetchSuccess, fetchFailure } = domainManagementSlice.actions;
export default domainManagementSlice.reducer;
